import cns from 'classnames'
import { memo } from 'react'

import { HeaderNFCS } from 'modules/nfcs/ui/HeaderNFCS'
import { HeaderWallet } from 'modules/wallet/ui/HeaderWallet'

import { Button } from 'shared/ui/controls/Button'
import { openWindow } from 'shared/utils/openWindow'

import { ReactComponent as V2Icon } from 'assets/v2.svg'
import { ReactComponent as ForwardIcon } from 'assets/forward.svg'

import s from './HeaderActions.module.scss'

type Props = {
  className?: string
}

function HeaderActionsRaw({ className }: Props) {
  return (
    <div className={cns(s.wrap, className)}>
      <HeaderNFCS className={s.nfcs} />
      <HeaderWallet className={s.wallet} />
      <Button
        onClick={() => openWindow('https://roci.fi/app')}
        fashion="glass-matte"
        className={s.changeVersion}
        size={40}
      >
        <div className={s.buttonContent}>
          <V2Icon />
          <ForwardIcon />
        </div>
      </Button>
    </div>
  )
}

export const HeaderActions = memo(HeaderActionsRaw)
